import React from 'react';
import ReactDOM from 'react-dom/client';
import { GlobalStateContext } from "./contexts/GlobalStateContext"
import App from './components/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GlobalStateContext>
      <App />
    </GlobalStateContext>
);
